<template>
  <div class="flex h-5 items-center gap-2">
    <div
      class="bg-ontick-blue-900 text-ontick-blue-300 flex h-full w-[60px] items-center justify-center rounded-sm"
    >
      <span>
        {{ symbolName }}
      </span>
    </div>
    <div
      class="bg-ontick-yellow-800 text-ontick-graphite-500 flex h-full w-5 items-center justify-center rounded-sm text-[10px] font-bold"
      :content="direction.tooltip"
      v-tippy="{ arrow: true, theme: 'green' }"
    >
      <span>
        {{ direction.label }}
      </span>
    </div>
    <symbol-progress-bar-v-2-component
      class="h-full"
      :max="plannedVolume"
      :filled="filledVolume"
      :text="text"
    />
    <trading-phase-icon-component :tradingPhase="tradingPhase" />
  </div>
</template>

<script>
import symbolProgressBarV2Component from "./symbol-progress-bar-v2.component.vue";
import TradingPhaseIconComponent from "./trading-phase-icon.component.vue";
export default {
  components: { symbolProgressBarV2Component, TradingPhaseIconComponent },
  props: {
    symbolName: {
      type: String,
    },
    symbolDirection: {
      type: String,
    },
    plannedVolume: {
      type: Number,
    },
    filledVolume: {
      type: Number,
    },
    tradingPhase: {
      type: String,
    },
    symbolPrice: {
      type: Number,
    },
    orderState: {
      type: String,
    },
  },

  computed: {
    direction() {
      switch (this.symbolDirection) {
        case "BUY":
          return {
            label: "C",
            tooltip: "Compra",
          };
        case "SELL":
          return {
            label: "V",
            tooltip: "Venda",
          };
        default:
          return {
            label: "-",
            tooltip: "Direção não identificada",
          };
      }
    },
    text() {
      let obj = {
        left: "",
        right: "",
      };
      if (
        ["ON_WAIT_ENTRY", "ON_WAIT_EXIT", "NEW"].includes(this.tradingPhase)
      ) {
        switch (this.tradingPhase) {
          case "ON_WAIT_ENTRY":
            obj.left = "Aguardando entrada";
            break;
          case "ON_WAIT_EXIT":
            obj.left = "Aguardando saída";
            break;
          case "NEW":
            obj.left = "Nova";
            break;
        }
        obj.right = null;
      } else {
        obj.left = Number(this.plannedVolume);
        obj.right = Number(this.symbolPrice);
      }
      return obj;
    },
  },
};
</script>

<style></style>
